import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { CaseWorkflow, WorkflowParticipant } from '@app/shared/models/workflow';
import {
    WorkflowParticipantsService,
    WorkflowParticipantUriBuilderParams
} from '@app/core/services/workflow/workflow-participants.service';
import { ParticipantsService} from '@app/core/services/participants.service';
import { ParticipantType } from '@app/shared/models/participant-type';
import { SelectComponentOptions } from '@app/shared/components/select/base-select-with-id.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NewParticipantComponent } from '@app/modules/case/components/new-participant/new-participant.component';


@Component({
    selector: 'case-workflow-participants',
    templateUrl: './case-workflow-participants.component.html',
    styleUrls: ['./case-workflow-participants.component.scss']
})
export class CaseWorkflowParticipantsComponent extends BaseWithBundleComponent
                                               implements OnInit {

    private _workflow: CaseWorkflow;

    @ViewChild('newParticipant')
    public newParticipant: NewParticipantComponent;

    @Input()
    set workflow(workflow: CaseWorkflow) {
        if (workflow) {
            const changed = this._workflow && this._workflow.id !== workflow.id;
            this._workflow = workflow;

            if (changed) {
                this.ngOnInit();
            }
        }
    }

    get workflow() {
        return this._workflow;
    }

    public participantTypeUriBuilderParams: WorkflowParticipantUriBuilderParams;
    public newParticipantPanelOpen: boolean;
    public participantTypeSelectOptions: SelectComponentOptions;

    public constructor(protected componentServiceBundle: ComponentServiceBundle,
                       protected workflowParticipantService: WorkflowParticipantsService,
                       protected participantsService: ParticipantsService
    ) {
        super(componentServiceBundle);
        this._idPrefix = 'participants.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.newParticipantPanelOpen = false;
        this.participantTypeUriBuilderParams = this.generateUriBuilderParams();

        this.participantTypeSelectOptions = {
            optional: false
        };

        this.workflow.defaults.participants.items.forEach(part => {
            part.displayName = this.participantsService.getTranslatedParticipantTypes(part);
        });
    }

    public create(type: ParticipantType): void {
        const participant = new WorkflowParticipant({
            type: [type]
        });

        this.workflowParticipantService.create(this.generateUriBuilderParams(), participant)
                                       .subscribe(result => {
            this.newParticipant.resetTypeSelect();
            this.workflow.defaults.participants.addItem(result);
            const part = this.workflow.defaults.participants.getItem(result.id);
            part.displayName = this.participantsService.getTranslatedParticipantTypes(part);
        }, err => this.handleError(err));
    }

    public delete(workflowParticipant: WorkflowParticipant): void {
        this.showSimpleConfirmDialog('common.dialog.delete.title',
                                          this.translateService.instant('common.dialog.delete.text', { name: workflowParticipant.displayName })
                                    ).subscribe((result) => {
            result && this.workflowParticipantService.delete(this.generateUriBuilderParams(workflowParticipant))
                                                     .subscribe(() => {
                this.workflow.defaults.participants.removeItem(workflowParticipant);
            }, err => this.handleError(err));
        });
    }

    protected generateUriBuilderParams(workflowParticipant?: WorkflowParticipant): WorkflowParticipantUriBuilderParams {
        return new WorkflowParticipantUriBuilderParams(this.workflow.target, this.workflow, workflowParticipant);
    }

    protected handleError(error: HttpErrorResponse | Error | string): void {
        this.showSimpleErrorSnackbar();
        super.handleError(error);
    }

}
